import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject, of } from "rxjs";
import { UserData } from "../models/identity/user-data";

@Injectable()
export class SecurityService {
    storage: Storage;
    private cachedUserData: UserData | null = null;
    private isAuthenticatedFlag: boolean | null = null;

    constructor(private httpClient: HttpClient) {
    }

    logout() {
        // Clear cached data
        this.cachedUserData = null;
        this.isAuthenticatedFlag = null;

        // Redirect to logout endpoint
        const logoutUrl = '/auth/logout';
        window.location.href = logoutUrl;
    }

    getUserData(): Observable<UserData> {
        // If this method is called again, return the cached user data
        if (this.cachedUserData) {
            return of(this.cachedUserData);
        }

        // If there is no cached data, return an observable that fetches the data
        const subj = new Subject<UserData>();

        // Fetch data from /auth/me
        this.httpClient.get<UserData>('/auth/me').subscribe((userData) => {
            // Set user data in this class
            this.cachedUserData = userData;
            subj.next(userData);
        });

        return subj;
    }

    isAuthenticated(): Observable<boolean> {
        // if it's true, return true
        if (this.isAuthenticatedFlag === true) {
            return of(true);
        }

        // if it's false check if the user is authenticated by calling /auth/isAuthenticated
        const subj = new Subject<boolean>();


        this.httpClient.get<boolean>('/auth/isAuthenticated').subscribe((res) => {
            this.isAuthenticatedFlag = res;
            subj.next(res);
        });

        return subj;
    }

    auth(): void {
        // set current URL in session storage as redirectUrl
        sessionStorage.setItem('redirectUrl', window.location.href);

        window.location.href = '/auth/login';
    }

    refresh(): void {
        this.httpClient.post('/auth/refresh', {}).subscribe();
    }
}
